import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment-timezone';
import { IUser } from 'src/modules/authentication/interfaces/user.interface';

@Injectable({
  providedIn: 'root'
})
export class StafferUtilService {
  constructor(private translate: TranslateService) {}

  getStafferContentAmerica(user: IUser) {
    const userName = user.firstName + ' ' + user.lastName;
    const contractSignedDateMoment =
      typeof user['contract_signed'] !== 'undefined'
        ? moment(user.contract_signed)
        : moment(parseInt(user._id.toString().substring(0, 8), 16) * 1000);

    const dayEstAgree = contractSignedDateMoment.date();
    const monthEstAgree = contractSignedDateMoment.month() + 1;
    const dateStafferAgree =
      (contractSignedDateMoment.month() + 1) + '/' + contractSignedDateMoment.date() + '/' + contractSignedDateMoment.year();
    const year = contractSignedDateMoment.year();

    return [
      {
        text: this.translate.instant('INDEPENDENT CONTRACTOR AGREEMENT'),
        style: 'header'
      },
      '\n\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-into-a') +
        this.translate.instant('STAFFER_CONTRACT.PARTS.usa-into-b') +
        this.translate.instant('STAFFER_CONTRACT.PARTS.usa-into-c') +
        ' ' +
        userName +
        ' ' +
        this.translate.instant('STAFFER_CONTRACT.PARTS.usa-into-d'),
      '\n\n',

      {
        text: this.translate.instant('STAFFER_CONTRACT.PARTS.USA-Introduction'),
        style: 'bolder'
      },
      '\n',
      this.translate.instant('The Company operates'),
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-into-para-a'),
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-into-para-b'),
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-into-para-c'),
      '\n',

      {
        text: this.translate.instant('Terms'),
        style: 'bolder'
      },
      '\n\n',

      {
        text: '1)' + this.translate.instant('STAFFER_CONTRACT.PARTS.CA-TERMS') + '.',
        style: 'bolder'
      },
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-terms-para-1')
      +
      ' ' 
      + dateStafferAgree + ' ' + this.translate.instant('STAFFER_CONTRACT.PARTS.usa-terms-para-2'),
      '\n',
      {
        text: '2) ' + this.translate.instant('STAFFER_CONTRACT.PARTS.CA-SERVICES') + '.',
        style: 'bolder'
      },
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-service-para'),
      '\n',
      {
        text: '3) ' + this.translate.instant('STAFFER_CONTRACT.PARTS.USA-FEES'),
        style: 'bolder'
      },
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-fees-para'),
      '\n',
      {
        text: '4) ' + this.translate.instant('STAFFER_CONTRACT.PARTS.CA-TERMINATION'),
        style: 'bolder'
      },
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-termination-para'),
      '\n',
      {
        text: '5)' + this.translate.instant('STAFFER_CONTRACT.PARTS.CA-RELATIONSHIP'),
        style: 'bolder'
      },
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-relationship-para'),
      '\n\n\n\n\n\n\n\n',
      {
        text: '6) ' + this.translate.instant('STAFFER_CONTRACT.PARTS.USA-INDEMNIFICATION'),
        style: 'bolder'
      },
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-ideminification-para'),
      '\n',
      {
        text: '7)' + this.translate.instant('STAFFER_CONTRACT.PARTS.USA-CONFIDENTIAL'),
        style: 'bolder'
      },
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-confidential-para'),
      '\n',
      {
        text: '8) ' + this.translate.instant('STAFFER_CONTRACT.PARTS.USA-NON-SOLICIITATION'),
        style: 'bolder'
      },
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-non-solicitation-para'),

      '\n',
      {
        text: '9) ' + this.translate.instant('STAFFER_CONTRACT.PARTS.USA-NONDISPARAGEMENT'),
        style: 'bolder'
      },
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-nondisparagement-para'),
      '\n',
      {
        text: '10) ' + this.translate.instant('STAFFER_CONTRACT.PARTS.USA-ENTIRE-AGREEMENT'),
        style: 'bolder'
      },
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-entire-agreement-para'),

      '\n',
      {
        text: '11) ' + this.translate.instant('STAFFER_CONTRACT.PARTS.USA-SUCCESSORS'),
        style: 'bolder'
      },
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-successiors-para'),
      '\n',
      {
        text: '12) ' + this.translate.instant('STAFFER_CONTRACT.PARTS.USA-SURVIVABILITYY'),
        style: 'bolder'
      },
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-survibilityy-para'),
      '\n',
      {
        text: '13) ' + this.translate.instant("STAFFER_CONTRACT.PARTS.USA-CHOICE'"),
        style: 'bolder'
      },
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-choice-para'),
      '\n',
      {
        text: '14) ' + this.translate.instant('STAFFER_CONTRACT.PARTS.USA-SEVERABILITY'),
        style: 'bolder'
      },
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-severability-para'),
      '\n',
      {
        text: '15) ' + this.translate.instant('STAFFER_CONTRACT.PARTS.USA-ARBITRATION'),
        style: 'bolder'
      },
      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.usa-arbitration-para'),
      '\n',

      this.translate.instant('STAFFER_CONTRACT.PARTS.in-witness-1'),

      '\n',
      this.translate.instant('STAFFER_CONTRACT.PARTS.in-witness-2') +
        this.translate.instant(' from ') +
        (user.ip ? user.ip : this.translate.instant('undetected')) +
        this.translate.instant(' IP address')
    ];
  }

  getStafferContent(user) {
    const userName = user.firstName + ' ' + user.lastName;

    let timeZone = 'America/' + (user.address.city === 'Mississauga' ? 'Toronto' : user.address.city);
    timeZone = timeZone === 'America/Houston' ? 'America/Chicago' : timeZone;
    const contractSignedDateMoment = moment().tz(timeZone);

    const dayEstAgree = contractSignedDateMoment.date();
    const monthEstAgree = contractSignedDateMoment.month() + 1;
    const dateStafferAgree =
      contractSignedDateMoment.year() + '/' + (contractSignedDateMoment.month() + 1) + '/' + contractSignedDateMoment.date();
    const year = contractSignedDateMoment.year();

    return [
      {
        text: 'Staffy Terms and Professional Addendum',
        style: 'header'
      },
      '\n\n',
      {
        "text": [
          {
            "text": " Staffy Canada Inc. (the ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Company”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": ") operates a digital platform (the ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Platform”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": ") (available at ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "www.staffy.com",
            "color": "blue",
            "decoration": [
              "underline"
            ],
            "style": [
              "html-a",
              "html-div",
              "para"
            ],
            "link": "http://www.staffy.com",
            "nodeName": "A"
          },
          {
            "text": " and through the Staffy mobile application) that connects healthcare, hospitality and other professionals (each such individual being a \"Professional\" as defined below) with enterprise Clients offering short-term working opportunities. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " Subject to the terms and conditions set forth in this Staffy Platform Services Agreement (together with any User Addendum incorporated herein by reference, the ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Agreement”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": "), the Company makes the Platform available to User for access and use on a remote basis via the Internet, and provides various related content, functionality, products, and services, as may be made available through the Platform from time to time (collectively, the ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Platform Services”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": "). ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " This Agreement governs the User’s access to and use of the Platform Services. ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "By clicking “ACCEPT”, or by otherwise accessing or using the Platform, User agrees with Company to be bound by this Agreement as either: (i) a Professional; or (ii) a Client (all capitalized terms as defined herein).  If an individual is agreeing to this Agreement on behalf of a corporation or other legal entity, such individual represents that he/she has the legal authority to bind such entity to this Agreement.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "1. DEFINITIONS",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": " The following capitalized words and expressions have the following meanings unless otherwise expressly provided in this Agreement: ",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Client”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means a Person who has registered for a Client Account on the Platform in accordance with this Agreement and who accesses or uses the Platform Services for the purpose of posting Shift Postings and hiring Professionals. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Client Account”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means a User Account for use by a Client. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Client Addendum”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means addendum that contains additional terms and conditions governing Client’s access to and use of the Platform Services, which may be incorporated into and made part of this Agreement, as applicable. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Client Content”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means any content uploaded, transferred, submitted or otherwise made available by Client to the Platform or Company, including Shift Postings and other materials relating to a Shift Posting provided by the Client. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Company Parties”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means Company, its affiliates, and their respective officers, directors, employees, agents, and any other parties working for or engaged by Company or otherwise involved in connection with the operation or administration of the Platform or the provision of Platform Services. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Company Privacy Policy”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means the Company’s privacy policy, available at: ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "https://staffy.com/privacy-policy",
            "color": "blue",
            "decoration": [
              "underline"
            ],
            "style": [
              "html-a",
              "html-div",
              "para"
            ],
            "link": "https://staffy.com/privacy-policy",
            "nodeName": "A"
          },
          {
            "text": ". ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Contract Services”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means the services provided by Professional to Client in connection with a Shift Posting. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Documentation”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means any available user guides and other documentation relating to the Platform Services made available (regardless of form) by Company. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Login Credentials”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " has the meaning given to it in Section 2.2. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Hosting Provider”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " has the meaning given to it in Section 4.3. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Parties”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means the Company and the User that has entered into this Agreement, with each being referred to respectively as a “Party” to this Agreement. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Person”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means an individual, a corporation, a partnership, a trust, an unincorporated organization, the government of a country or any political subdivision thereof, or any agency or department of any such government, and the executors, administrators or other legal representatives of an individual in such capacity. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Platform Enhancements”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means any and all improvements, modifications, upgrades and updates (including revisions, patches, improvements, modifications, enhancements, corrections and new releases) to the Platform Services, including those designed to improve the capabilities or performance of the Platform Services and third-party tools. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Platform Service Fee”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " has the meaning given to it in Section 6.2. For certainty, Platform Service Fees include any transaction fees or other fees charged by any third-party payment processors. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Professional”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means a Person who has registered for a Professional Account on the Platform in accordance with this Agreement and who accesses or uses the Platform Services for the purpose of responding to Shift Postings posted on the Platform by Clients and performing Contract Services for Clients. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Professional Account”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means a User Account for use by a Professional. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Professional Addendum”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means the addendum that contains additional terms and conditions governing Professional’s access to and use of the Platform Services, which may be incorporated into and made part of this Agreement, as applicable. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Professional Content”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means any content uploaded, transferred, submitted or otherwise made available by Professional to the Platform or Company, which may include biographic materials, profile photographs, and any other materials relating to Professional and Professional’s response to a Shift Posting. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Registration Information”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " has the meaning given to it in Section 2.1. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Shift”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means a scheduled period of time during which Professional is to provide the Contract Services to Client. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Shift Posting”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means a written description prepared by or on behalf of a Client for posting on the Platform, which describes the available Shift, Work Site, and scope of work required by the Client, and may include other information such as information that may be required by or prompted by the Platform. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Third Party Service”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " has the meaning given to it in Section 7.1. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Third Party Terms”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " has the meaning given to it in Section 7.1. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“User”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means the Professional or Client, as the context may indicate or require, that is agreeing to this Agreement. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“User Account”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " has the meaning given to it in Section 2.1. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“User Addendum”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means the Professional Addendum or the Client Addendum, as the context may indicate or require. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“User Content”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means Client Content or Professional Content, as the context may indicate or require. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": " ",
            "style": [
              "html-div",
              "para"
            ]
          },
          {
            "text": "“Work Site”",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " means the location at which the Contract Services are to be performed, as requested by the Client. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "2. REGISTRATION",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "2.1 User Account.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": "  In order to access the Platform and receive Platform Services, User must register on the Platform and create a unique user account by completing the relevant registration forms prompted by the Platform (the “User Account”).  User will need to register for a Client Account if User agrees to be bound by this Agreement as a Client, and User will need to register for a Professional Account if User agrees to be bound by this Agreement as a Professional, in each case as prompted by the Platform.  User is responsible to provide true, accurate, current, and complete information as prompted by the registration forms (“Registration Information”), including contact, payment, and billing information, as applicable, and User shall maintain and update such information to ensure that it is true, accurate, current, and complete at all times.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "2.2 Account Security.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Each User Account requires a name, email address, and password (the “Login Credentials”). Login Credentials may also include other security and authentication information used by the Platform. User is responsible for maintaining the confidentiality of User’s Login Credentials and for all activities that occur under such Login Credentials. User may not: (a) disclose User’s Login Credentials to anyone else, or (b) attempt to gain control of or use any other person’s Login Credentials. User shall immediately change User’s password and notify Company if User’s Login Credentials are compromised in any way (including upon becoming aware that there has been any unauthorized access or use of the User’s User Account or Login Credentials, or that there has been any other breach of security related to a User Account). Company will not have any liability to User for any use or transaction made using User’s Login Credentials or User Account (whether or not authorized by the User), and Company will not be liable for any loss or damage arising from User failure to comply with this Section 2.2.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "2.3 Additional Terms.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " If User is a Professional, then the Professional Addendum (which includes additional terms and conditions governing Professional’s access to and use of the Platform Services) will apply. If User is a Client, then the Client Addendum (which includes additional terms and conditions governing Client’s access to and use of the Platform Services) will apply. The applicable User Addendum is incorporated into and made part of this Agreement.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "3. PERMITTED USE",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "3.1 Permitted Use.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Subject to User’s compliance with this Agreement, Company hereby authorizes User to access the Platform and make use of the Platform Services solely for the purposes described in the applicable User Addendum and in accordance with this Agreement.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "3.2 Responsibilities.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " User: (a) is responsible for all activity it conducts using the Platform Services; (b) shall comply with all applicable laws relating to its use of the Platform Services; (c) shall comply with all policies adopted by Company and posted on the Platform from time to time regarding the Platform Services; and (d) shall provide all equipment necessary to establish a connection to the Internet, access to the Internet, and any telephone, wireless or other connection and service fees associated with such access.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "3.3 Restrictions.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " In accessing and using the Platform Services, User shall not:",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(a) make any modifications or enhancements to the Platform, or create any derivative work based on the Platform;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(b) remove any proprietary notices and notations in or on the Platform that refer to the confidentiality of or the intellectual property rights of Company or Company’s licensors;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(c) interfere or attempt to interfere with the proper workings or security or integrity of the Platform;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(d) attempt to gain unauthorized access to any part of the Platform other than those parts of the Platform to which User has been given express permission by Company;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(e) transmit any unwanted communications through or using the Platform Services, including any advertising, bulk email, solicitations, spam, or any unlawful, threatening, abusive, defamatory, obscene, sexually explicit, or profane materials;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(f) transmit any virus, malware, or other harmful data or code through or using the Platform Services;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(g) use or attempt to use the Platform for any illegal purposes or otherwise in any manner not contemplated by the Documentation;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(h) infringe any intellectual or proprietary rights of Company any other party;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(i) access or use the Platform Services in any way which may disrupt or impair: (i) the functionality of the Platform, (ii) the use of the Platform by Company or any other Person, or (iii) any systems used for the Platform Services; or ",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(j) decompile, disassemble, reverse engineer or otherwise attempt to reconstruct or discover the source code, design, or underlying programming sequences, methodologies and techniques of any component of the Platform except to the extent permitted by applicable law.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "3.4 Warranties and Representations.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " User represents and warrants that:",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(a) User has the legal capacity and rights, power and authority, and all necessary consents and approvals, to execute, deliver and perform all of its obligations under this Agreement and without the payment of any fees, royalties or other amounts to any other person;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(b) User is, if an individual, of the legal age of majority under applicable law to form binding contracts with other persons and entities, and, if not an individual, User has legal capacity to form binding contracts with other persons and entities;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(c) none of the authorization, creation, execution or delivery of this Agreement nor compliance with or performance of the terms and conditions of this Agreement (including the licenses and assignments made herein) has resulted in or will result in a breach of, or constitute a default under, any agreement, understanding, undertaking or instrument (including, if User is a corporation, its articles, by-laws or other constituting documents and any resolutions passed by its board of directors or shareholders) to which it is a party or by which it or its property is or may be bound;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(d) the performance or receipt of the Contract Services, as applicable, will not violate or infringe any third party rights nor give rise to any third party claims and is provided in compliance with all applicable laws, regulations, regulatory guidelines, policies and codes and industry guidelines, policies and codes; and",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(e) it has and it will comply with all applicable laws and regulations in the performance of this Agreement and its obligations hereunder.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "3.5 Suspension.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Company reserves the right, at its sole discretion, to suspend, with or without notice to User, User’s access to any (or all) Platform Services if Company reasonably determines that User is in breach of this Agreement or otherwise engaging in acts contrary to the policies of Company or any Documentation. For certainty, such suspension does not affect either Party’s rights and obligations accrued prior to such suspension (including with respect to Contract Services provided by or to User prior to such suspension). ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "4. THE PLATFORM AND PLATFORM SERVICES",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "4.1 Availability.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " The Platform is intended to be generally available seven days per week, 24 hours per day, except for downtime for system maintenance and other reasons beyond Company’s control. Company does not guarantee or warrant that all or any portion of the Platform will be accessible at all times, or that User Content will be backed up or can be accessed at all times. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "4.2 Security.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Company has implemented security policies and practices that are designed to protect the security and integrity of the Platform. However, no data transmission over the Internet or other communication network or systems can be guaranteed to be secure, and there is always risk that an unauthorized third party could thwart the security measures that the Company has implemented, including by intercepting transmissions. COMPANY DOES NOT GUARANTEE THE SECURITY OF COMMUNICATIONS AND DATA PROVIDED OR TRANSMITTED THROUGH THE PLATFORM.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "4.3 Hosting Provider.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " User acknowledges and agrees that Company (or its licensors) may operate the Platform, provide the Platform Services, and store content and data (including User Content) using services, infrastructure, and software provided by third parties (“Hosting Providers”), which may be located in a jurisdiction outside of the jurisdiction in which User resides. User shall comply with any policies and terms of any Hosting Provider that are applicable to User and of which Company provides User with notice.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "4.4 Changes.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Company reserves the right to suspend, modify or update the Platform Services (or any part thereof) at any time in Company’s sole discretion without notice to User (including to change or reduce or eliminate any features or functionalities of the Platform). Company does not guarantee continued compatibility with any Third Party Service.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "4.5 Nature of the Platform Services.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " User acknowledges and agrees that in providing the Platform Services, Company merely provides a digital tool to assist: (a) Clients to create and publicize Shift Postings for the purpose of procuring Contract Services; and (b) Professionals to respond to Shift Postings and provide Contract Services. User expressly acknowledges and agrees that: (i) Company is not a placement agency; and (ii) in providing Contract Services, Professionals will be acting at all times as independent contractors of the applicable Client, and not as employees of the Company or the Client for any purpose whatsoever.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "4.6 Ownership.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " All right, title, and interest, including all intellectual property rights, in and to the Platform, Platform Services, and Platform Enhancements (including any solution enhancements created using any feedback or suggestion provided by User) are, and will be, owned solely and exclusively by Company or its licensors, as applicable. Except for the limited rights to use the Platform Services expressly provided to User under this Agreement, Company reserves all rights in and to the Platform Services and no implied rights or licenses are granted.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "5. USER CONTENT",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "5.1 Ownership and License.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " User retains ownership of any User Content, and intellectual property rights in and to the User Content, provided by User to Company or submitted by User to the Platform. Each User hereby grants to Company (and any third party authorized by Company) an irrevocable, perpetual, worldwide, unrestricted, fully paid up, royalty free, non-exclusive right and license to store, reproduce, publish, display, disclose, transmit, modify, and otherwise use and process User Content (in whole or in part, as is or as may be modified) and any materials based on or derived from User Content for the purpose of providing the Platform Services, facilitating User’s access to and use of the Platform Services, and advertising and promoting the Company and Company’s products and services. User hereby waives all moral rights (and all other rights of a like or similar nature) that User may have in the User Content. For certainty, Company may publicly identify User as a customer of Company, and use any logos or trademarks provided by User to Company, in connection with Company’s advertising and promotional activities.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "5.2 Responsibility for User Content.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " User acknowledges that Company does not independently evaluate, investigate, or otherwise conduct any due diligence regarding any User Content provided by Clients or Professionals, and Company has no liability to User for any damage or loss concerning the accuracy of any User Content or User’s access to, or use of, or reliance on, any User Content (whether User Content of the User or of another Client/Professional). All User Content is the sole responsibility of the User from whom such User Content originated. Company disclaims any and all liability relating to User Content. All User Content is used by User at its own discretion and sole risk.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "5.3 User Content Details.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " User represents and warrants that all User Content provided to Company or made available to and through the Platform by User is: (a) true, accurate and current; (b) does not and will not, directly or indirectly, infringe, violate or breach any duty toward or rights of any person or entity, including without limitation any copyright, trademark, service mark, trade secret, other intellectual property, publicity or privacy right; and (c) provided in compliance with all applicable laws, regulations, regulatory guidelines, policies and codes and industry guidelines, policies and codes.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "5.4 Use of User Content by Third Parties.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " User acknowledges that certain User Content provided to Company or submitted to the Platform (such as Shift Postings and Professional biographical details) may be accessible by other Clients and Professionals, and Company cannot guarantee that any further dissemination of User Content will be subject to Company’s control. User hereby releases Company from any and all liability related to the dissemination, reproduction, distribution, display or use of User Content by a third party.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "5.5 Right to Remove or Refuse Content.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Company reserves the right to remove or decline to post to the Platform any User Content that violates the terms of the Agreement or for any other reason that the Company determines, in its sole discretion, including that such User Content presents a business, legal, or security risk to Company, other Users or any other Persons. Company will not be liable for any damages arising from Company’s removal of any User Content or Company’s refusal to post any User Content. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "6. FEES AND PAYMENT",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "6.1 Payment for Contract Services.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " If User is a Professional, then User will invoice Company and be paid in accordance with the Professional Addendum. If User is a Client, then User will receive invoices from Company (on behalf of the Professional/Professionals providing Contract Services to that User) and will pay for Contract Services in accordance with the Client Addendum.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "6.2 Platform Service Fees.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Company (and providers of Third Party Services, where applicable) may impose a transaction charge, use fee, or other amount in respect of certain Platform Services (“Platform Service Fees”). Platform Service Fees may be set out in the applicable User Addendum, or may otherwise be disclosed to User through the Platform. Where applicable, Company may deduct such Platform Service Fees from amounts otherwise payable to User, include such Platform Service Fees in or with fees otherwise payable by User, or separately invoice User for such Platform Service Fees. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "6.3 Payment Processing.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Company may use a third-party payment processor. The processing of payments in connection with the use of the Platform Services will be subject to the terms, conditions, and privacy policies of the payment processor (and where applicable, payment card issuer). Company is not responsible for any errors by the payment processor and User shall resolve any disputes for amounts charged (or paid/not paid) directly with the payment processor. In connection with User’s use of the Platform Services, Company will obtain certain transaction details, which Company will use solely in accordance with the data processing and privacy terms of this Agreement and the Company Privacy Policy. User will be responsible to obtain all necessary authorizations and consents to process User credit cards and other permitted payment cards and methods.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "6.4 Taxes.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Company’s fees are exclusive of any applicable taxes which may be assessed by any governmental authority having jurisdiction. User will pay to Company or, if required by the Company or by the governmental authority, to the applicable governmental authority the amount of any applicable taxes levied based on the User’s performance of its obligations and exercise of its rights under this Agreement. If any taxes are withheld and paid to a governmental authority, User will increase the amount of fees paid to Company in respect of the withheld amounts so that Company receives and retains the full amount owing from User. Company is responsible for taxes assessable against it based on its income.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "7. THIRD PARTY SERVICES",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "7.1 Third Party Terms.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " The Platform may include features or links that direct User to, or allow User to access, use, or interact with, third party websites, applications, content, products, and services (“Third Party Services”). When User accesses, uses, or interacts with any Third Party Service, their own terms and privacy policies (“Third Party Terms”), in addition to this Agreement, as applicable, will apply. If there is any inconsistency between this Agreement and such Third Party Terms, then the applicable Third Party Terms will apply to such Third Party Services to the extent of the inconsistency. User is solely responsible for all fees, charges, and expenses associated with any Third Party Services. To the extent that User elects to access, use or interacts with any Third Party Services, User authorizes Company to disclose User Content and other information provided by the User (including financial information and personal information) to the applicable third party for the purpose of facilitating User’s access to, use of, or interaction with such Third Party Services.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "7.2 No Liability for Third Party Services.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " All Third Party Services are used by User on an “as-is” basis, and User accesses, uses, or interacts with such Third Party Services at User’s sole risk. Company will have no liability to User for any damage or loss in connection with User’s access to, use of, or interaction with, any Third Party Services (including with respect to any unauthorized disclosure, use, or loss of any User Content or other information provided by the User). User hereby irrevocably releases Company and other Company Parties from any and all claims and liabilities associated with User’s access to, use of, or interaction with, any Third Party Services.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "8. PRIVACY POLICIES",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "The collection, use, and disclosure of personal information in connection with User’s access to and use of the Platform Services will be subject to and governed by the Company Privacy Policy, which is incorporated into and made part of this Agreement by reference. User is responsible for its compliance with all applicable privacy laws, and User confirms that all personal information provided by User to Company or submitted to the Platform have been provided in compliance with all applicable laws.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "9. DISCLAIMER",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "The Platform and Platform Services are provided on an “as is” and “as available” basis and at User’s own risk. Except as expressly set forth in this Agreement, Company makes no representations or warranties of any kind or nature, whether express or implied, and Company expressly disclaims, to the full extent permissible under applicable law, any and all warranties and conditions of any kind, including without limitation: (a) fitness for a particular purpose; (b) non-infringement of third party rights; (c) that the Platform Services will always be available, accessible, uninterrupted, timely, secure, free of malicious code or virus, or operate without error; (d) that any errors can or will be corrected. ",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "10. RISK MANAGEMENT",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "10.1 Limitations and Exclusions.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " To the maximum extent permitted by law, in no event will Company be liable to User or any third party for any indirect, special, incidental, consequential, or punitive damages however caused, whether in contract, tort or under any other theory of liability or for any other damages, including loss of revenue or profits, loss of, or damage to, reputation, indirectly arising out of or related to this Agreement (including any User Addendum), the Platform or Platform Services, any User Content, or any Contract Services, whether or not such damages could reasonably be foreseen or their likelihood has been disclosed to Company. In no event shall Company’s total aggregate liability arising out of or related to this Agreement (including any User Addendum), the Platform or Platform Services, any User Content, or any Contract Services, whether in contract, tort or under any other theory of liability, exceed the Platform Service Fees paid by the User (where the User is a Client) or the Platform Service Fees collected by Company in respect of User’s use of the Platform (where the User is a Professional), during the three month period immediately preceding the date on which the cause of action arose.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "10.2 Limitations Apply.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " User acknowledges that in entering into this Agreement and setting the fees Company has relied on the limitations and exclusions of liability set forth in this Agreement as a fundamental and essential part of the Parties’ agreement. Accordingly, the limitations and exclusions set forth in this Agreement apply irrespective of the cause of action, demand or claim or theory of liability, including an action, in contract, negligence, tort, by statute or otherwise, and shall survive breaches and/or the failure of the essential purpose of this Agreement.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "10.3 Limitation Period.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " No action arising out of or in connection with this Agreement may be brought by User more than one year after the date on which the cause of action has accrued.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "11. INDEMNIFICATION",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "User shall defend, indemnify and hold harmless Company and the Company Parties from and against any and all claims, damages, liabilities, losses, costs and expenses (including legal expenses, fines, fees and the cost of investigation and resolution), arising out of, relating to or in any connection with any claim, action, suit or proceeding by, or settlement with, any third party (including another User) based on, or arising as a result of: (a) User’s breach of any warranty, representation, grant, license or waiver of rights or agreement made in this Agreement; or (b) any User Content provided or submitted by User. ",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "12. MUTUAL AGREEMENT TO ARBITRATE DISPUTES (“ARBITRATION PROVISION”)",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "12.1 Agreement to Arbitrate",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(a) If any dispute, disagreement, claim or difference arises out of or relating to this Agreement or the Contract Services between the Company and the User, or the User and the Company or any Company Parties (a “Dispute”), the Party raising the Dispute shall promptly provide written notice to the other Party. The Parties agree to first attempt to resolve any disputes or claims amicably through discussion between the Parties. If the Parties are unable to reach a resolution amicably within 30 days of the delivery of a Dispute Notice by one Party on the other Party, and except as provided explicitly in Section 12.7, the Parties hereby agree that, to the fullest extent permitted by law, any and all disputes or claims between User and Company, whether in contract, tort, or otherwise arising out of or in any way relating to this Agreement, the Platform Services, the Contract Services, or the relationship between the Parties, including but not limited to any disputes or claims regarding the formation (including any assertion of unconscionability or invalidity), existence, breach, termination, services, scope, validity, enforceability, applicability, or interpretation of the relationship between the Parties or this Agreement, shall be exclusively resolved by final and binding arbitration. ",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(b) For additional clarity, by agreeing to this Agreement, User hereby expressly waives, to the extent permitted by applicable law, their right to have any dispute or claim resolved by a court, unless specifically set out herein.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "12.2 Arbitration Procedures and Location.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " All Disputes will be finally resolved by arbitration before a single arbitrator under the Simplified Arbitration Rules of the ADR Institute of Canada, Inc. (the “ADRIC Simplified Rules”, and the “Institute”, respectively), except that the Parties will ask the Institute to deliver to all parties a list of at least three individuals from which the parties may agree to select an arbitrator. If the Parties do not agree to select an arbitrator within 14 days of receipt of the list from the Institute, the arbitrator will be appointed by the Institute in accordance with the ADRIC Simplified Rules.  The Seat of Arbitration (as defined in the ADRIC Simplified Rules) will be Toronto, Ontario. Unless the parties otherwise agree or the arbitrator orders otherwise, the location of evidentiary or other arbitration hearings shall be the province where the User is performing or receiving Contract Services and in the city that is geographically closest to where the User is located in the province that has a population greater than 100,000; provided that in the event that there is no such city in the province, hearings will be held: (i) in such location as the parties may mutually agree to, or (ii) in the absence of such agreement, the provincial capital. The language of the arbitration will be English.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "12.3 Arbitration Costs, Lawyers’ Fees, and Costs.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " The arbitrator shall have the power to award and apportion the arbitration costs (including the arbitrator’s fees and expenses) in accordance with the ADRIC Simplified Rules. Each Party shall otherwise pay its own lawyers’ fees and costs. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "12.4 Awards.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " The arbitrator is authorized to award any remedy or relief available under applicable law that the arbitrator deems just and equitable, including any remedy or relief that would have been available to the parties had the matter been heard in a court. The decision of the arbitrator shall be in writing and shall provide the reasons for the award unless the parties agree otherwise.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "12.5 Waiver of Class Action Claims.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " User and Company hereby agree that each Party may bring and pursue claims against the other Party (or in the case of User, against any Company Parties) only in their individual capacities, and may not bring, pursue, or act as a plaintiff, class representative, or class member in any purported class or collective proceeding or action other than on an individual basis except to the extent this provision is unenforceable as a matter of law. Notwithstanding any other provision in this Agreement, if the waiver set forth in this Section 12.5 is found to be unenforceable, the Parties agree that any class or collective action claims will be litigated in a court of competent jurisdiction and not as a class or collective arbitration.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "12.6 Waiver of Other Representative Proceedings and Jury Trial",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(a) The Parties hereby agree that, to the extent permitted by applicable law, any and all dispute resolution proceedings will be conducted only on an individual basis and not in a collective, consolidated, or on the basis of a joinder of proceedings.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(b) If for any reason a dispute, claim, or controversy proceeds in a court rather than in arbitration, to the extent permitted by applicable law, the Parties hereby further waive any right to a jury trial and agree that any such court proceeding will also be conducted only on an individual basis and not in a class, representative, collective, consolidated, or on the basis of a joinder of proceedings.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "12.7 Claims Not Covered.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Disputes or claims between Company and any third party beneficiaries are also not covered by the terms of this Arbitration Provision. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "13. TERM AND TERMINATION",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "13.1 Term.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " This Agreement shall become effective at the time User accepts this Agreement and shall apply for the duration of time that User uses the Platform Services, or for any specific term or period to which a User subscribes, unless earlier terminated by either Party as permitted by this Agreement. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "13.2 Renewal.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " If User has subscribed for a specific term or period (e.g. annual or monthly or on some other basis), then at the end of each such period, this Agreement will be automatically renewed for a period of time of the same duration as the immediately preceding term or period.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "13.3 Termination – Particular Events.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Company may immediately terminate this Agreement or, without limiting its other rights and remedies, suspend, User’s access to the Platform Services without notice upon the occurrence of any of the following events: (a) User fails to make any payments when due; (b) User fails to comply with any provision of this Agreement; or (c) User files an assignment in bankruptcy or is or becomes bankrupt or insolvent, upon the appointment of a receiver for all or substantially all of the property or assets of the User, upon the making of any assignment or attempted assignment for the benefit of creditors or on the institution by User of any act or proceeding for the winding up of its business. If Company terminates or suspends the User’s access to the Platform Services or this Agreement under this Section, User understands and agrees that User will not receive a refund of, or credit for, any fees paid. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "13.4 Other Termination.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Company reserves the right to terminate this Agreement or suspend or terminate User’s access to the Platform Services (or any part of the Platform Services): (a) upon five days’ notice to User for any reason whatsoever; or (b) immediately, if User does not agree to accept an amended version of this Agreement as amended in accordance with Section 14. In the event that Company terminates or suspends the User’s access to the Platform Services or this Agreement under this Section 13.4, User will receive a pro-rata refund of any prepaid fees paid to Company for which Platform Services have not been provided. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "13.5 Termination by Users.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " User may cease to use the Platform Services at any time subject to the terms of this Agreement concerning the payment of fees.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "13.6 Effects of Termination.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " In the event of a termination of the Agreement:",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(a) Company shall cease providing the Platform Services, and User’s access to the Platform and Platform Services shall terminate;  ",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(b) User will remain obligated to make any payments due hereunder which remain unpaid; ",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(c) Company will provide the User with 30 days to retrieve any User Content it has submitted to the Platform; and",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(d) Company may (but has no obligation to) remove any User Content and delete any User information or related details.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "Termination of this Agreement will not affect any Party’s accrued rights or liabilities. Company will not be responsible or liable to User for User’s inability to access or use any User Content or any other portion of the Platform after termination of this Agreement.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "13.7 Survival.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " The following Sections of this Agreement, and such other terms as are necessary to give effect to the surviving terms, will survive any termination of this Agreement: 3.4, 4.5, 4.6, 5, 6 (with respect to any outstanding payment), 7, 8, 9, 10, 12, 13.5, 13.6, and 15.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "14. Amendments",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "Company may amend this Agreement at any time. The most current version of this Agreement will always be posted on the Platform and prior versions will remain available for review. If the terms of this Agreement are revised, Users will be required to agree to the updated Agreement the next time the User logs in to the Platform. Unless otherwise agreed to between User and Company, if User does not agree to the revised Agreement, User will not be permitted to continue accessing the Platform and using the Platform Services. This Agreement may also be amended by a separate written document that is made in writing, dated and executed by the Parties. This Agreement cannot otherwise be amended or modified. ",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "15. General Provisions",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "15.1 Notice.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " All required notices, or notices which may be provided in accordance with this Agreement, shall be in writing and shall be duly provided for if the notice is remitted to its addressee by pre-paid courier, registered or certified mail, or e-mail, if to Company to the address listed on the contact portion of the Platform, and if to the User to the address set out on its profile included in the Registration Information. Every notice delivered in the manner provided for herein shall be deemed to have been received: when delivered or if by e-mail the first business day after the date received unless the sender receives a notice of delivery failure in which case another permitted method of notice will be used.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "15.2 Compliance with Laws.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " User is solely responsible for complying with, and User shall comply with, all applicable laws in connection with User’s access to and use of the Platform Services. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "15.3 Entire Agreement.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " This Agreement (including, for certainty, the applicable User Addendum) contains the complete and exclusive statement of the agreement between the Parties relating to the subject matter of this Agreement, and supersedes all prior and contemporaneous agreements, purchase orders, understandings, proposals, negotiations, representations, or warranties of any kind whether written or oral. No oral or written representation between the Parties that is not expressly contained in or explicitly provided for by this Agreement is binding on either Party.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "15.4 Governing Law.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " This Agreement will be interpreted in accordance with and governed by the laws of the Province of Ontario, Canada, without regard to any conflict of law principles that would cause the application of any other law. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "15.5 Assignment.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " This Agreement will be binding upon and will enure to the benefit of and be enforceable by each of the Parties hereto, their respective successors and permitted assigns. User may not assign, delegate or transfer all or any part of this Agreement (or any of User’s rights or obligations) without the prior consent of Company. Company may assign this Agreement without User’s consent at any time. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "15.6 Relationship.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " This Agreement is not to be construed as creating any partnership, agency (except as expressly provided) relationship, employment relationship or any other form of legal association or entity that would impose liability upon one Party for the actions or failure of the other. For greater certainty, the Parties are independent contractors.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "15.7 Waiver.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Failure to exercise or enforce any right or provision shall not affect Company’s right to exercise or enforce such right or provision at any time thereafter, nor shall a waiver of any breach or default of this Agreement constitute a waiver of any subsequent breach or default or a waiver of the provision itself. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "15.8 Severability.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " If any provision of the Agreement is held by a court of competent jurisdiction to be invalid or unenforceable in any respect, then the remaining provisions of the Agreement, or the application of such provisions to persons or circumstances other than those as to which it is invalid or unenforceable shall not be affected thereby, and each such provision of the Agreement shall be valid and enforceable to the extent granted by law.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "15.9 Currency.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " All amounts referred to in this Agreement are expressed in Canadian dollars, unless specifically indicated otherwise.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "15.10 Force Majeure.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Company shall not be liable for any failures or delay in the performance of its obligations hereunder caused by an event beyond its reasonable control, including acts of God, User’s acts or omissions, third party product or service failures, Internet or telecommunications outages, acts of civil or military authorities, fire, strikes, power surges or outages, pandemics, epidemics, flood, earthquakes, riot, or war. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "15.11 Interpretation.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " In this Agreement: (a) the division of this Agreement into Sections and the insertion of headings are for convenience of reference only and will not affect the construction or interpretation of this Agreement; (b) “including” means “including without limitation”, and “includes” means “includes, without limitation”; (c) unless the context requires otherwise, words importing the singular include the plural and vice versa, and words importing gender include all genders; (d) if any payment is required to be made or other action is required to be taken pursuant to this Agreement on a day which is not a business day, then such payment or action will be made or taken on the next business day; (e) any reference in this Agreement to any statute or any section thereof will, unless otherwise expressly stated, be deemed to be a reference to such statute or section as amended, restated or re-enacted from time to time; (f) all Company stated rights and remedies are not exclusive and are in addition to any other available rights and remedies.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "15.12 English Language.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " The parties have expressly required that this Agreement and all related documents, including notices and other communications, be drawn up in English exclusively. Les parties ont expressément exigé à ce que la présente convention ainsi que tous les documents qui s'y rattachent, incluant les avis et autres communications, soient rédigés en anglais exclusivement. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "Professional Addendum",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " This Professional Addendum (“Addendum”) is incorporated into and made part of the Staffy Platform Services Agreement (the “Agreement”), which governs Professional’s access to and use of the Platform Services. For certainty, references to the Agreement also refer to this Addendum. In the event of any conflict between this Addendum and the body of the Agreement, this Addendum applies to the extent of the conflict. Capitalized terms used but not defined in this Addendum have the meanings described in the body of the Agreement. ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "1. PERMITTED USE",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "1.1 Permitted Use.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Professional may access and use the Platform Services solely for the purpose of: (a) setting search parameters and searching for, reviewing and selecting, and responding to Shift Postings; (b) coordinating and agreeing with applicable Clients to provide Contract Services; (c) invoicing for Contract Services, entering into corresponding payment arrangements, and collecting payment for Contract Services performed; (d) communicating with Company with regard to the Platform Services; and (e) any other use of the Platform Services explicitly permitted by the Company to further the Professional’s business interests as a healthcare, hospitality, or other type of professional in respect of which Shift Postings are available on the Platform (including, in particular, the assembly or transmission of professional biographic materials and other Professional Content on the Platform and the use of the Platform’s rating system); all in accordance with the terms and conditions set forth in this Addendum and elsewhere in the Agreement.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "2. CONTRACT SERVICES",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "2.1 Responding to Shift Postings.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Professional may search for and review the Shift Postings on the Platform, and offer to provide Contract Services to Clients in respect of Shift Postings. If Professional’s offer to provide Contract Services is accepted by the Client, then Professional and Client will coordinate via the Platform to confirm the particular Shift to be serviced by Professional, and other related details; a Shift confirmation notice (“Shift Confirmation Notice”) will be generated by the Platform to evidence Professional and Client’s mutual agreement to the Contract Services to be performed, the Shift start and end times, the Professional’s hourly rate and terms of payment for the Contract Services, and other applicable terms. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "2.2 Evaluating Shift Postings.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Professional shall be solely responsible to evaluate the Clients and Shift Postings on the Platform. Company makes no representations or guarantees regarding the suitability of any Shift Posting to Professional or the accuracy of any Shift Posting or any information provided through the Platform’s rating system or otherwise. Professional acknowledges that Company does not have any obligation to verify the accuracy of any information provided by any Client.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "2.3 Company’s Role",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(a) Professional acknowledges that Company will not be involved in any aspect of the performance of Contract Services, and that Company will have no liability for any acts or omissions of any Client. Professional performs all Contract Services for the applicable Clients, and at Professional’s sole risk. ",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(b) If Professional is injured in the course of performing the Contract Services or at the Work Site, Professional is solely responsible for reporting the injury to the applicable workers’ compensation board (such as the Workplace Safety and Insurance Board of Ontario) (“Worker’ Compensation Board”), if any, and claiming any benefits or compensation from the applicable Worker’ Compensation Board, where applicable; Company will have no obligation to assist Professional in connection with any such claims, but may, if requested by a Worker’ Compensation Board, cooperate with such Worker’ Compensation Board in investigating the injury. ",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(c) Professional further acknowledges that any Client’s decision to accept or reject an offer by Professional to provide Contract Services in respect of any Shift Posting is made at Client’s sole discretion (notwithstanding that Company may provide suggestions or display reviews or ratings of Professionals to Clients through the Platform). ",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "2.4 Providing Contract Services as Agreed to with Client.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Professional agrees to perform Contract Services for Client(s) by attending the Shift(s) as mutually agreed with Client(s) at the Work Site(s) designated by Client(s), as set out in the applicable Shift Confirmation Notice. Professional represents that Professional shall provide Contract Services in a professional, skillful, timely and commercially reasonable manner consistent with industry standard practices. When providing Contract Services in response to a particular Shift Posting, the Professional shall take such direction from the applicable Client that is commensurate with the Professional’s status as a professional service provider and independent contractor. Professional is responsible for providing any uniform and tools, and obtaining any qualifications or training, required for the performance of the Contract Services, and for travelling to and from the Work Site, all as to be agreed upon with applicable Client(s). Professional acknowledges that any costs or expenses incurred by the Professional related to the performance of the Contract Services are the sole responsibility of the Professional and that neither Client nor Company have any obligation to reimburse Professional for any such costs or expenses. When Professional is performing Contract Services at a Work Site, Professional is solely responsible for resolving any disputes arising in connection with the Contract Services directly with the Client; if any such disputes arise, or if Professional would otherwise like to make any complaints about a Client, after the applicable Contract Services have been completed, then, before Professional notifies Client of such dispute or complaint or otherwise take any legal action in respect of such dispute or complaint, Professional shall first notify Company and, if requested by Company, shall reasonably cooperate with Company and the Client to resolve the dispute or complaint through good faith negotiations and discussion with Company and the Client.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "2.5 Licenses and Permits.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " The Professional shall be responsible for obtaining all licences and permits as are required of the Professional to lawfully and professionally provide the Contract Services to Clients. The Professional shall be responsible for complying with all applicable federal, provincial, and municipal laws, codes, and regulations, including applicable taxation laws, in connection with the provision of the Contract Services hereunder. The Professional shall, upon request, provide the Client and/or Company with adequate evidence in respect of same. To the extent that any such evidence is provided to Company, Professional agrees that such evidence is provided for purposes of demonstrating the Professional’s ability to provide the Contract Services to Clients, and that the Company may share such evidence and related materials with Clients to the extent Clients or Company deems this to be necessary or advisable.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "2.6 Professional Covenants and Obligations.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " In addition to Professional’s other obligations as set forth in this Agreement, Professional shall:",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(a) obtain Professional’s own appropriate insurance coverage with adequate limits of liability, if and as required for the Professional to lawfully and professionally provide the Contract Services; further, upon request by Client or Company, the Professional shall provide adequate evidence of Professional’s insurance coverage; to the extent that any such evidence is provided to Company, Professional agrees that such evidence is provided for purposes of demonstrating the Professional's ability to provide the Contract Services to Clients, and that the Company may share such evidence and related materials with Clients to the extent Clients or Company deems this to be necessary or advisable; and",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(b) comply with all requirements of the Income Tax Act (Canada), Canada Pension Plan (Canada), and Employment Insurance Act (Canada) (if any, including in particular to the extent that the Professional is registered as a self-employed person thereunder), and all other applicable laws and legal requirements with respect to Professional’s business; without limiting the generality of the foregoing, Professional shall pay or remit to the appropriate authorities any income, sales, use, value-added or other taxes, Canada Pension Plan contributions, employment insurance premiums, or any interest, fines, penalties or other charges of any kind that may be collectible, payable, claimed or levied in respect of the payments received by the Professional in respect of the provision of the Contract Services.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "2.7 Client Feedback.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " From time to time, Company may solicit or receive feedback regarding Professional (or Professional’s performance of Contract Services) from Clients, which feedback may be provided in the form of a rating system. Professional acknowledges that Company may make such Client feedback available to other Clients or generally disclose or display such Client feedback on the Platform or for purposes of promoting the Platform. Company will not be liable for, and Professional hereby releases Company in respect of, any feedback provided by any Client (even if such feedback is disclosed to third parties or displayed on the Platform, or elsewhere, for public viewing).",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "3. ADDITIONAL REQUIREMENTS",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "3.1 Additional Client Terms.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Client may include non-disclosure requirements or other terms and conditions that the Client requires to apply to the Shift Posting and Professional’s performance of the Contract Services (“Additional Client Terms”). In accepting any Shift Posting for which such Additional Client Terms are specified, Professional agrees to abide by such Additional Client Terms and, in any event, shall accept and abide by such Additional Client Terms immediately before and at the time of performing the corresponding Contract Services.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "3.2 Additional Professional Policies.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " From time to time, Company may require Professional to agree to additional policies applicable to Professional’s performance of the Contract Services or Professional’s use of the Platform before Professional is permitted to respond to Shift Postings or to continue using the Platform. For greater certainty, such additional policies do not include any internal Company policies applicable to employees or other representatives of Company; and any such internal Company policies expressly do not apply to Professional.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "3.3 Additional Requirements.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Company may, in Company’s sole discretion, invite or require Professional to provide additional information and fulfill additional requirements, before Company permits Professional to use (or to continue to use) the Platform Services or respond to Shift Postings, in whole or in part. Such additional requirements may include (but are not limited to) the requirements described in this Section 3.3:",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(a) Company may request Professional to provide additional biographical details (such as job histories) to Clients or Company Parties, or through the Platform;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(b) Company may request Professional to provide references (and contact information of such references) to Clients or Company Parties; by providing such contact information, Professional authorizes Clients and Company to contact the applicable references;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(c) Company may require Professional to provide certain credentials (which may be general in nature or specific to particular Clients) prior to Professional’s performance of any or specific Contract Services; unless otherwise agreed to by the Parties or by particular Clients, to the extent that any credentials require additional training, Professional must attend such training on Professional’s own time and Company will not be required to compensate Professional for the completion of any such training;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(d) Company may request Professional to provide the results of, or submit to, background checks or other security screenings, in each case at the Professional’s cost, before Professional is permitted to perform any Contract Services; where applicable, background checks and security screenings may be conducted by third parties authorized by Company or Client(s), and may be subject to additional terms and conditions; the Company Privacy Policy will govern with respect to any personal information provided by Professional in response to such security screening; and",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(e) Company may require Professional to agree to non-disclosure agreements for the protection of the confidential information of Company or Clients before Professional is permitted to respond to Shift Postings on the Platform.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "4. INDEPENDENT CONTRACTOR RELATIONSHIP",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "Professional acknowledges and agrees that, in performing the Contract Services, Professional will be acting (and shall act at all times) as an independent contractor, and not as an employee of the Client (or of the Company) for any purpose whatsoever, including, without limitation: for purposes relating to benefits, taxes, payments required by statute or any other withholdings or remittances to any governmental agency or authority, and control over how the Professional provides specific Contract Services. Neither this Agreement, the relationship created between the Parties pursuant to this Agreement, nor any course of dealing between the Professional, Company, and any Client is intended to create, or shall create, an employment relationship, a joint venture, partnership or any similar relationship. Professional further acknowledges and agrees that, as an independent contractor, the Professional will not be qualified to participate in or to receive any vacation, vacation pay, holiday pay, severance or termination pay, notice or pay in lieu of notice, disability benefits, insurance, pensions, retirement plans, or any other benefits offered or provided by Company or Client to their respective employees. Professional will have no authority to, and will not exercise or hold itself out as having any authority to, enter into or conclude any contract or to undertake any commitment or obligation for, in the name of or on behalf of the Company or any Client.  Professional will not hold itself out as or otherwise describe itself as an employee of Company or of any Client for any purpose. ",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "5. SUBCONTRACTING",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "Unless otherwise specified or agreed upon between Professional and Client (including, without limitation, further to any Additional Client Terms for specific Shift Postings), Professional is not prohibited from subcontracting its provision of Contract Services to third parties or from otherwise hiring a replacement for the Professional with respect to the provision of any Contract Services that the Professional has agreed to provide. In the event of any such subcontracting, Professional remains responsible for the provision of the Contract Services and remains bound by all terms of this Agreement in any way relating thereto. Further, Professional shall be solely liable for any benefits, taxes, payments, obligations, liabilities, expenses or costs, as required by applicable law and arising from the Professional’s subcontracting for the provision of Contract Services to third parties.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "6. COMPENSATION AND PAYMENT",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "6.1 Compensation.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " The Professional will be paid based on an hourly rate and the length of the Shift; the hourly rate applicable in respect of different Shift Postings may vary depending on the Contract Services performed by the Professional for such Shift Postings and as agreed to between Client and Professional.  The hourly rate applicable to any particular Contract Services will be set out in the corresponding Shift Confirmation Notice.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "6.2 Invoicing.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(a) Professional is responsible for using the Platform to generate an invoice for the Contract Services performed for a Client (“Contract Service Invoice”). Contract Service Invoices are generated by the Professional through the on-premise verification function of the Platform to record the time the Contract Services begin and end; the start time for providing particular Contract Services must be recorded on the Platform upon starting to provide those Contract Services, and the completion of those Contract Services must be recorded on the Platform at the time of completion. Professional acknowledges that Company may collect location information directly from Professional’s mobile device in accordance with the Company Privacy Policy for the purpose of confirming time the Contract Services began and ended and verifying the information recorded by Professional. Invoices must include all prescribed information requested by Company or prompted by the Platform, including the Professional’s GST/HST registration information.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(b) If Professional fails to record via the Platform the start and end times for the provision of particular Contract Services to a Client, then Professional is responsible to contact Company through the Platform (or at the email address indicated in the Platform) and provide supporting information/documentation as reasonably required by Company, so that Company personnel may record the start and/or end of the completed Contract Services on Professional’s behalf. ",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(c) If, after recording and confirming the start and end times of their provision of Contract Services using the Platform, Professional wishes to revise those start or end times, then Professional may contact Company through the Platform (or at the email address indicated in the Platform), and Company personnel may revise the start or end times as requested by Professional provided that Professional has provided supporting information/documentation as reasonably required by Company to support the revision, and subject to the payment of a $20.00 adjustment fee by Professional (which adjustment fee is, for greater certainty, deemed to be a Platform Service Fee under Section 6 of the Agreement and may be deducted from the relevant Contract Service Invoice).",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "6.3 Payment.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Subject to Section 6.4 of this Addendum, Company will pay amounts set forth in each Contract Service Invoice to Professional, on behalf of Client, and less any Platform Service Fees, within 15 days after receipt of corresponding payment by Company from Client (or within a shorter period of time as may be agreed to between Company and Professional, subject to such additional or alternative payment terms as may be applicable).",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "6.4 Client-Initiated Disputes and Claw Back",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(a) If Client notifies Company of any dispute in connection with the Contract Services (“Client-Initiated Dispute”), including any allegation by a Client that the Professional has failed to complete the Contract Services as agreed or in a manner satisfactory to the Client, then Company may: (1) with respect to disputed amounts not yet paid to Professional, withhold the payment to Professional of any amounts received from Client for any Contract Service Invoices; or (2) with respect to disputed amounts already paid to Professional, set-off and deduct, from amounts otherwise payable to Professional (including from any other Professional Service Invoices), any amount disputed by a Client, in each case unless and until the Client notifies Company that the Client-Initiated Dispute has been resolved to Client’s satisfaction and instructs Company to release the relevant payment to Professional. It is Professional’s responsibility to resolve the Client-Initiated Dispute directly with the Client. Company may, but has no obligation to, help facilitate the resolution of such Client-Initiated Dispute by cooperating with Client and Professional in their investigation and negotiations relating to the Client-Initiated Dispute. With respect to any disputed amounts that have not yet been paid by Company to Professional, if Client does not notify Company within a reasonable time (and in any event within 15 days after Client first notifies Company of such Client-Initiated Dispute) that the Client-Initiated Dispute has been resolved in Professional’s favour, then Company may refund (or may reallocate/otherwise credit) any such disputed amount to Client; if a disputed amount is so refunded (or reallocated/otherwise credited) to Client, Company will have no further obligations in respect of the Client-Initiated Dispute and it will be Professional’s responsibility to obtain any amounts properly owed by a Client to Professional directly from the Client. In no event shall Company be responsible for payment of any Contract Service Invoice, or any part thereof, except to the extent that (i) Company has received corresponding payment of such portion of the Contract Service Invoice in question, (ii) Client has not requested or received a refund (or reallocation/crediting) of such payment, and (iii) Client notifies Company that any Client-Initiated Dispute pertaining to such Contract Service Invoice has been resolved to Client’s satisfaction and in Professional’s favour.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(b) If Professional fails to attend to a Work Site to perform Contract Services that have been agreed to and confirmed by Professional on the Platform as set out in the Shift Confirmation Notice, then Company reserves the right to withhold and deduct, from amounts invoiced by Professional and otherwise payable by Company, a cancellation fee (“Cancellation Fee”) up to an amount equal to four hours multiplied by Professional’s agreed-upon rate for the missed Contract Services.  Professional agrees that such Cancellation Fee represents a reasonable estimate of the damages suffered by Company and Client due to Professional’s failure to perform, and does not represent a penalty to Professional. ",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(c) Any withholding of payment by Company, or Cancellation Fee charged by Company, in accordance with this Addendum will not limit Company’s other rights and remedies under the Agreement (including Company’s right to terminate Professional’s use of Platform Services). ",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(d) For the avoidance of doubt, Professional expressly acknowledges that Company reserves the right to set-off, deduct, and otherwise make corrections in any Contract Service Invoice for any amounts otherwise payable to Professional, to account for any amounts disputed by Clients (including amounts disputed in respect of any other Contract Service Invoice) or any unpaid Platform Service Fees, Cancellation Fees, or other amounts owed by Professional to Client or Company.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "7. INDEMNIFICATION BY PROFESSIONAL",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "In addition to Professional’s indemnification obligations set forth elsewhere in the Agreement, Professional shall defend, indemnify and hold harmless Company and the Company Parties from and against any and all claims, damages, liabilities, losses, costs and expenses (including legal fees/expenses, fines, fees and the cost of investigation and resolution), arising out of, relating to or in any connection with any claim, action, suit or proceeding by, or settlement with, any third party (including another Professional or any Client) based on, or arising as a result of:",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(a) Professional’s performance of the Contract Services;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(b) personal injury (including death) or property damage caused by any action or inaction of the Professional;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(c) the Professional’s gross negligence, willful misconduct, or fraud; ",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(d) failure by Professional to perform the Contract Services in compliance with applicable law or with instructions given to Professional by the applicable Client;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(e) any breach by Professional of any Additional Client Terms (as described in Section 3.1 of this Addendum);",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(f) any use or disclosure of any data or information provided by a Client to Professional or otherwise made accessible to Professional by a Client in connection with Contactor’s performance of the Contract Services;",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(g) any failure to deduct, withhold, remit or contribute any amount in respect of Company payments to the Professional under this Agreement, including with respect to any and all federal or provincial taxes levied against Professional or in respect of Professional’s provision of Contract Services, federal or provincial pension plan contributions, employment insurance premiums, workplace safety and insurance premiums and contributions under any federal or provincial social insurance or income security programs; or",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(h) any determination (including by any governmental authority) that the relationship between Professional and Company (or Professional and Client, as applicable) is other than as set forth in this Agreement. Without limiting the generality of the foregoing, in the event of a ruling or other determination by any court, tribunal, or other governmental authority that, contrary to the understanding of the Parties, the Professional is or is deemed to be an employee of the Company (or the Client), the Professional shall indemnify and hold harmless and shall reimburse the Company in respect of:",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(i) any payments or withholdings the Company is required to make in respect of or for the benefit of the Professional, including but not limited to the Professional’s or Company’s portion of income tax withholding, employment insurance premiums and Canada Pension Plan contributions in respect of the Professional’s provision of any Contract Services; and",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "(ii) any penalties levied on the Company in respect of the period for which the Professional was remunerated or the Professional’s provision of any Contract Services.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "8. NON-SOLICITATION AND NON-DISPARAGEMENT",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "8.1 Professional Representation and Warranty.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " The Professional hereby represents and warrants to the Company that it is not party to any written or oral agreement with any third party that would restrict its ability to enter into this Agreement or to perform the Professional’s obligations hereunder and that the Professional will not, by providing services to the Company (or to a Client), breach any non-disclosure, proprietary rights, non-competition, non-solicitation or other covenant in favor of any third party.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "8.2 Non-Solicitation.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Professional hereby agrees that, during the term of this Agreement and for 45 days following the termination of this Agreement, the Professional will not directly or indirectly solicit or attempt to solicit, any Client, customer, or supplier of the Company (or of any Client) in a manner that conflicts with or interferes in the business of the Company. ",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "8.3 Employment with Clients.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " Subject to receiving the Company’s advance written consent, and other than through the Professional’s reasonable use of the Platform Services to facilitate the hiring by Client(s) of the Professional to provide Contract Services through the Platform, Professional shall not enter into any relationship directly or indirectly (including, for greater certainty, as either an employee or an independent contractor) with any Client for whom Professional has previously performed Contract Services until 45 days after Professional last performed any Contract Services for such Client.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": [
          {
            "text": "8.4 Non-Disparagement.",
            "nodeName": "B",
            "bold": true,
            "style": [
              "html-b",
              "html-div",
              "para"
            ]
          },
          {
            "text": " For the term of this Agreement and thereafter, Professional shall not, and shall not cause or cooperate with others to, publicly criticize, ridicule, disparage or defame the Company or its products, services, policies, directors, officers, shareholders, or employees, with or through any written or oral statement or image (including, but not limited to, any statements made via websites, blogs, postings to the internet, or emails, and whether or not they are made anonymously or through the use of a pseudonym). This non-disparagement obligation does not apply to statutorily privileged statements made by Professional to governmental or law enforcement agencies.",
            "style": [
              "html-div",
              "para"
            ]
          }
        ],
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "9. COMMUNICATIONS",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "Company may communicate with Professional (including by email, push notification, andtext messages) in connection with Professional’s access to and use of the Platform Services, including to alert Professional to Shift Postings and to support Professional’s use of the Platform Services. Professional acknowledges that message and data rates may apply to such communications and that Professional is solely responsible for all charges and fees associated therewith. Professional may opt out of communications relating to Shift Postings or other promotional communications using the unsubscribe mechanism included in such communications or through device settings (for push notifications).",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "10. TERMINATION",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "In addition to Company’s rights to terminate this Agreement set forth elsewhere in the Agreement, Company reserves the right to terminate this Agreement, and Professional’s access to the Platform, upon notice to Professional, if: (a) Professional repeatedly fails to attend to a Work Site to perform Contract Services agreed to and confirmed by Professional on the Platform; (b) Company receives complaints from any Clients regarding Professional’s performance of Contract Services; (c) Company otherwise determines that Professional has acted in a manner harmful to any Company Parties or Clients.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "11. SURVIVAL",
        "nodeName": "H1",
        "fontSize": 16,
        "bold": true,
        "style": [
          "html-h1",
          "para-heading"
        ]
      },
      {
        "text": " ",
        "style": []
      },
      {
        "text": "In addition to any other provisions specifically identified as surviving termination of the Agreement, the following Sections of this Addendum, and such other terms as are necessary to give effect to the surviving terms, will survive any termination of this Addendum: 4, 5 (with respect to any disputes or outstanding payments), 7, 8, and 10.",
        "nodeName": "DIV",
        "style": [
          "html-div",
          "para"
        ]
      },
      {
        "text": "",
        "nodeName": "DIV"
      },
      {
        "text": " ",
        "style": []
      },
      '\n\n',
      {
        columns: [
          { text: 'Name: ' + userName, width: '50%' },
          { text: 'Signature: ' + dateStafferAgree, width: '50%' }
        ],
        style: 'para'
      },
      '\n',
      {
        text: 'IP Address: ' + (user.ip ? user.ip : 'undetected'),
        style: 'para'
      }
    ];
  }
}
